/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { defaultGeomatique } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_pres_003: Question = {
  id: 'pres-003-portrait-bandes-riveraines',
  oldId: '17',
  title: 'Portrait des bandes riveraines (ou milieux riverains)',
  number: '2.3',
  description: ['Pourcentage des cours d’eau bordés par des bandes riveraines significatives'],
  type: QuestionType.INDICATOR,
  frequency: 3,
  slots: [
    {
      type: SlotTypes.GEOMATIQUE,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: true,
      optional: false,
      scoringFct: (data: string[]) => data,
      score: '0',
      help: defaultGeomatique,
      unit: SlotUnit.PERCENTAGE,
    },
  ],
};

const question_pres_003__v3: Question = {
  ...question_pres_003,
  frequency: 4,
};

export const question_pres_003_v2: Question = question_pres_003;
export const question_pres_003_v3: Question = question_pres_003__v3;
